import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";

export const generatePdf = ({
  data,
  vendorDetails,
  pdfTitle,
  columns,
  pharmacy,
}) => {
  const {
    address: vendorAddress = "",
    name: vendorName = "",
    phone: vendorPhone = "",
  } = vendorDetails || {};

  const [{ address = "", name = "", phone = "" } = {}] = pharmacy || [];

  const time = new Date().getTime();

  try {
    const doc = new jsPDF();

    const headers = columns.map((col) => col.Header);
    const accessors = columns.map((col) => col.accessor || col.field);

    const rows = data.map((item) =>
      accessors.map((accessor) => {
        let value = item[accessor];

        if (accessor === "quantity") {
          return value;
        }

        if (typeof value === "string" && value.match(/^\d{4}-\d{2}-\d{2}/)) {
          return moment(value).format("DD/MM/YYYY");
        }

        return value;
      })
    );

    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 10;
    const sectionWidth = (pageWidth - 2 * margin) / 3; // Divide into three equal parts
    const lineHeight = 5; // Line height for text

    // PDF title and date
    doc.setFontSize(14); // Reduced title font size
    doc.text(pdfTitle, pageWidth / 2, 10, { align: "center" });
    doc.setFontSize(10); // Reduced date font size
    doc.text(
      `Date: ${moment(new Date()).format("DD/MM/YYYY")}`,
      pageWidth - margin,
      10,
      { align: "right" }
    );

    // Vendor details (To Address) on the left
    let currentY = 20;
    doc.setFontSize(10); // Reduced font size for addresses
    doc.text("To,", margin, currentY);
    currentY += lineHeight;

    const vendorDetailsLines = doc.splitTextToSize(
      `${vendorName}\n${vendorAddress}\nMobile: ${vendorPhone}`,
      sectionWidth
    );
    doc.text(vendorDetailsLines, margin, currentY);
    currentY += vendorDetailsLines.length * lineHeight;

    // Pharmacy details (From Address) on the right
    const rightStartX = margin + 2 * sectionWidth; // Start position for right section
    currentY = 20;
    doc.text("From,", rightStartX, currentY, { align: "left" });
    currentY += lineHeight;

    const pharmacyDetailsLines = doc.splitTextToSize(
      `${name}\n${address || ""}\nMobile: ${phone}`,
      sectionWidth
    );
    doc.text(pharmacyDetailsLines, rightStartX, currentY, { align: "left" });

    // Table of data
    doc.autoTable({
      head: [headers],
      body: rows,
      startY: Math.max(
        currentY + pharmacyDetailsLines.length * lineHeight,
        40
      ), // Start table below the longer section
      margin: { left: margin, right: margin },
      styles: {
        fontSize: 10, // Reduced table font size
      },
    });

    // Footer with page numbers
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.text(
        `Text at the end of Page ${i}`,
        pageWidth / 2,
        doc.internal.pageSize.getHeight() - 10,
        { align: "center" }
      );
    }

    // Save the PDF
    doc.save(`${pdfTitle}_${time}_${vendorName}.pdf`);
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
};
